import { rem } from '@mantine/core'

export default {
  xs: rem(2),
  sm: rem(4),
  md: rem(8),
  lg: rem(12),
  xl: rem(20),
  none: rem(0),
  pill: '50%'
}
